import {
    SET_FORM_LIBRARY_NAME,
    SET_FORM_LIBRARY_LIST,
    SET_FORM_LIBRARY_PAGE,
    SET_PAGE_LIMIT_REACHED,
    ADD_FORM_LIBRARY_LIST,
    SET_FORM_LIBRARY_STATUS,
    SET_FORM_LIBRARY_SEARCH_TERM,
    SET_EVENT_THEME_COUNT,
    VALIDATE_FORM_DATA_FOR_SAVING,
    SET_FORM_LIBRARY_ERROR,
    SET_FORM_LIBRARY_FORM_ID,
    SET_SCALED_FORM_MODAL_STATUS_OPEN,
} from '../constants/actionTypes';

export const setFormName = (formId, name) => ({
    type: SET_FORM_LIBRARY_NAME,
    payload: {
        formId,
        name,
    },
});

export const setLibraryFormStatus = (status) => ({
    type: SET_FORM_LIBRARY_STATUS,
    payload: status,
});

export const setScaledFormModalStatusOpen = (bool) => ({
    type: SET_SCALED_FORM_MODAL_STATUS_OPEN,
    payload: bool,
});

export const setLibraryFormList = (formList) => ({
    type: SET_FORM_LIBRARY_LIST,
    payload: formList,
});

export const addLibraryFormList = (formList) => ({
    type: ADD_FORM_LIBRARY_LIST,
    payload: formList,
});

export const setFormLibraryPage = (page) => ({
    type: SET_FORM_LIBRARY_PAGE,
    payload: page,
});

export const setPageLimitReached = (limitReached) => ({
    type: SET_PAGE_LIMIT_REACHED,
    payload: limitReached,
});

export const setFormLibrarySearchTerm = (searchTerm) => ({
    type: SET_FORM_LIBRARY_SEARCH_TERM,
    payload: searchTerm,
});

export const setEventThemeCount = (payload) => ({
    type: SET_EVENT_THEME_COUNT,
    payload,
});

export const saveFormAsCopy = (formId) => ({
    type: VALIDATE_FORM_DATA_FOR_SAVING,
    payload: formId,
});

export const setFormLibraryError = (hasError) => ({
    type: SET_FORM_LIBRARY_ERROR,
    payload: hasError,
});

export const setFormLibraryFormId = (formId, formLibraryFormId) => ({
    type: SET_FORM_LIBRARY_FORM_ID,
    payload: {
        formId,
        formLibraryFormId,
    },
});
